import axios from './axiosConfig'

export const fetchCompanyData = async (cin) => {
  try {
    console.log('company data fetching')
    const response = await axios.get(`/graph/company/${cin}`)
    console.log('company data fetched', response.data)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error('Company data not found for this CIN')
    }
    throw new Error(error.response?.data || 'Something went wrong')
  }
}

export const companyInfoData = async (cin) => {
  try {
    const response = await axios.get(`/graph/company/${cin}`)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error('Company data not found for this CIN')
    }
    throw new Error(error.response?.data || 'Something went wrong')
  }
}

export const fundRaiseData = async (cin) => {
  try {
    const response = await axios.get(`/graph/fund/${cin}`)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error('Fund Raise not found for this CIN')
    }
    throw new Error(error.response?.data || 'Something went wrong')
  }
}

export const grossGraphData = async (cin) => {
  try {
    const response = await axios.get(`/graph/gross/${cin}`)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error('Financial data not found for this CIN')
    }
    throw new Error(error.response?.data || 'Something went wrong')
  }
}

export const getAllGraph = async () => {
  console.log('inside graph')
  const response = await axios.get('/graph')
  console.log('graphs:', response.data)
  return response.data
}

export const getGraphById = async (id) => {
  const response = await axios.get(`/graph/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createGraph = async (formData) => {
  console.log('formdata:', formData)
  const data = new FormData()

  // Required fields
  data.append('cin', formData.cin || formData.cinWorld)
  data.append('brandName', formData.brandName)

  // Optional fields - only append if they have values
  if (formData.hideInfoBox === false) {
    if (formData.companyName) {
      data.append('companyName', formData.companyName)
    }
    if (formData.yearIncorporation) {
      data.append('yearIncorporation', formData.yearIncorporation)
    }
    if (formData.industry) {
      data.append('industry', formData.industry)
    }
    if (formData.grossRevenue) {
      data.append('grossRevenue', formData.grossRevenue)
    }
    if (formData.ebitda) {
      data.append('ebitda', formData.ebitda)
    }
    if (formData.netProfitLoss) {
      data.append('netProfitLoss', formData.netProfitLoss)
    }

    if (formData.image && formData.image[0]) {
      data.append('image', formData.image[0])
    }
  }

  // for graph
  if (formData.hideGraph === false) {
    console.log('inside graph')
    if (formData.grossYear) {
      data.append('grossYear', formData.grossYear)
    }
    if (formData.otherIncome) {
      data.append('otherIncome', formData.otherIncome)
    }
    if (formData.grossRevenueData) {
      data.append('grossRevenueData', formData.grossRevenueData)
    }
    if (formData.grossExpensesData) {
      data.append('grossExpensesData', formData.grossExpensesData)
    }
  }

  // for fund raise graph
  if (formData.hideFundRaise === false) {
    console.log('inside fund raise graph')
    if (formData.fundRaiseYear) {
      data.append('fundRaiseYear', formData.fundRaiseYear)
    }

    if (formData.fundRaiseAmount) {
      data.append('fundRaiseAmount', formData.fundRaiseAmount)
    }

    if (formData.fundRaiseRound) {
      data.append('fundRaiseRound', formData.fundRaiseRound)
    }
  }

  // Handle boolean properly
  data.append('hideInfoBox', formData.hideInfoBox ? 'true' : 'false')
  data.append('hideGraph', formData.hideGraph ? 'true' : 'false')
  data.append('hideFundRaise', formData.hideFundRaise ? 'true' : 'false')

  console.log('creating deal with FormData:')
  // Log FormData contents for debugging
  for (let [key, value] of data.entries()) {
    console.log(`${key}:`, value)
  }

  try {
    const response = await axios.post('/graph', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating graph:', error)
    throw error
  }
}

export const updateGraph = async (id, formData) => {
  const data = new FormData()

  // Required fields - always append these

  data.append('cin', formData.cin || formData.cinWorld || '')
  data.append('brandName', formData.brandName || '')

  // Optional fields - only append if they have values
  if (formData.hideInfoBox === false) {
    if (formData.companyName) {
      data.append('companyName', formData.companyName)
    }
    if (formData.yearIncorporation) {
      data.append('yearIncorporation', formData.yearIncorporation)
    }
    if (formData.industry) {
      data.append('industry', formData.industry)
    }
    if (formData.grossRevenue) {
      data.append('grossRevenue', formData.grossRevenue)
    }
    if (formData.ebitda) {
      data.append('ebitda', formData.ebitda)
    }
    if (formData.netProfitLoss) {
      data.append('netProfitLoss', formData.netProfitLoss)
    }

    if (formData.image && formData.image[0]) {
      data.append('image', formData.image[0])
    }
  }

  // for graph
  if (formData.hideGraph === false) {
    console.log('inside graph')
    if (formData.grossYear) {
      data.append('grossYear', formData.grossYear)
    }
    if (formData.otherIncome) {
      data.append('otherIncome', formData.otherIncome)
    }
    if (formData.grossRevenueData) {
      data.append('grossRevenueData', formData.grossRevenueData)
    }
    if (formData.grossExpensesData) {
      data.append('grossExpensesData', formData.grossExpensesData)
    }
  }

  // for fund raise graph
  if (formData.hideFundRaise === false) {
    console.log('inside fund raise graph')
    if (formData.fundRaiseYear) {
      data.append('fundRaiseYear', formData.fundRaiseYear)
    }

    if (formData.fundRaiseAmount) {
      data.append('fundRaiseAmount', formData.fundRaiseAmount)
    }

    if (formData.fundRaiseRound) {
      data.append('fundRaiseRound', formData.fundRaiseRound)
    }
  }

  // Handle boolean properly
  data.append('hideInfoBox', formData.hideInfoBox ? 'true' : 'false')
  data.append('hideGraph', formData.hideGraph ? 'true' : 'false')
  data.append('hideFundRaise', formData.hideFundRaise ? 'true' : 'false')

  console.log('Updating deal with FormData:')
  // Log FormData contents for debugging
  for (let [key, value] of data.entries()) {
    console.log(`${key}:`, value)
  }

  try {
    const response = await axios.put(`/graph/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating graph:', error)
    throw error
  }
}

export const fetchSearch = async (query) => {
  try {
    console.log('Fetching search results for query:', query)
    const response = await axios.get(`/graph/search?q=${query}`)
    console.log('Fetched search results:', response.data)
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // throw a special error message
      throw new Error('Competitor Not Found, try other')
    }
    console.error('Error fetching search results:', error)
    throw error
  }
}

// Add Graph form data from companies already uploaded as Excel, by name, brand or CIN.
// One result per query: { query, status: 'found' | 'ambiguous' | 'not_found', company?, candidates? }
export const prefillGraphs = async (queries) => {
  const params = new URLSearchParams()
  queries.forEach((q) => params.append('q', q))
  const response = await axios.get(`/graph/prefill?${params.toString()}`)
  return response.data?.results || []
}
